import React, { createContext, useContext, useState } from 'react';
import { OrderItemTableContextType } from './interface';

export const OrderItemTableContext = createContext<OrderItemTableContextType>({} as OrderItemTableContextType);

export function OrderItemTableContextProvider({ children }: { children?: React.ReactNode }) {
  const pageSize = 10;
  const [tableItemOrderBy, setTableItemOrderBy] = useState('number asc');
  const [currentPageItem, setCurrentPageItem] = useState(0);

  const uploadTableItemOrderBy = (value: string) => setTableItemOrderBy(value);
  const uploadCurrentPageItem = (value: number) => setCurrentPageItem(value);

  return (
    <OrderItemTableContext.Provider value={{ pageSize, tableItemOrderBy, uploadTableItemOrderBy, currentPageItem, uploadCurrentPageItem }}>
      {children}
    </OrderItemTableContext.Provider>
  );
}

export const useOrderItemTableContext = () => useContext(OrderItemTableContext);
